import { render, staticRenderFns } from "./PaymentTransactionsCollectedList.vue?vue&type=template&id=13bd6244"
import script from "./PaymentTransactionsCollectedList.vue?vue&type=script&lang=js"
export * from "./PaymentTransactionsCollectedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports